import script from "./AlertNewFlowModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./AlertNewFlowModal.vue?vue&type=script&lang=ts&setup=true"

import "./AlertNewFlowModal.vue?vue&type=style&index=0&id=01f0bd4f&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01f0bd4f"]])

export default __exports__